import { OrderSuccess } from '@/plugins/popups'
import { generalError } from '@/plugins/popups'
import eventBus from '../../plugins/eventBus'
import api from '@/plugins/api'
import Model from 'scomponent/src/data/model'
import fieldTranslation from '../../../.env.models.json'
import { OrderDetailModel } from './OrderDetailModel'
import Store from 'scomponent/src/data/store'

export class OrderModel extends Model {
  private static instance: OrderModel = new OrderModel()
  id: number = 0
  date: Date = new Date()
  value: number = 0
  paymentMethods: string = ''
  status: string = ''
  statusId: number
  details: Store<OrderDetailModel> = new Store<OrderDetailModel>(
    OrderDetailModel,
    fieldTranslation['OrderDetail']
  )

  public static getInstance(): OrderModel {
    this.instance.setTranslateField(fieldTranslation['Order'])
    return OrderModel.instance
  }

  public postOrder(payload: any, successCallback?: any, errorCallback?: any) {
    if (!successCallback) {
      successCallback = () => {}
    }
    if (!errorCallback) {
      errorCallback = () => {}
    }
    api()
      .post('orders', payload)
      .then(response => {
        if (response && response.status) {
          OrderSuccess()
          successCallback()
          eventBus.$emit('close_checkout_modal')
          localStorage.removeItem('cart')
          eventBus.$emit('remove-cart-items')
          return
        }
        generalError()
        errorCallback()
      })
      .catch(error => {
        errorCallback()
      })
  }
}
